import ReverseChargeDeterminer from "@/module/Form/ReverseCharge/Strategy/ReverseChargeDeterminer";
import ForeignCustomerDeterminer from "@/module/Form/VatDeterminer/ForeignCustomerDeterminer";

export default class ForeignCustomerWithDicReverseChargeDeterminer
  implements ReverseChargeDeterminer
{
  private foreignCustomerDeterminer: ForeignCustomerDeterminer;

  constructor(foreignCustomerDeterminer: ForeignCustomerDeterminer) {
    this.foreignCustomerDeterminer = foreignCustomerDeterminer;
  }

  async determinate(
    country: string | null = null,
    ic: string | null = null,
    dic: string | null = null,
    icDph: string | null = null,
  ): Promise<boolean> {
    const vatId = country === "SK" ? icDph : dic;

    return (
      this.foreignCustomerDeterminer.isForeignCustomer(country) &&
      vatId !== null &&
      vatId !== ""
    );
  }
}
